import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectAppAuthReady,
  selectAppAuthLoading,
  selectAppIsAuthenticated,
} from "../redux/appAuthSlice";
import { THEME } from "../theme";

const AppProtectedRoute = ({ children }) => {
  const location = useLocation();
  const authReady = useSelector(selectAppAuthReady);
  const loading = useSelector(selectAppAuthLoading);
  const isAuthenticated = useSelector(selectAppIsAuthenticated);

  if (!authReady || loading) {
    return (
      <div
        className="flex min-h-[40vh] items-center justify-center"
        style={{ backgroundColor: THEME.background }}
      >
        <div className="text-sm font-semibold text-white/55">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/app/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children;
};

export default AppProtectedRoute;
